// extracted by mini-css-extract-plugin
module.exports = {"app":"index_app__2lpzC"};